import { PixAdjustLimitsAssignatureComponent } from './master/pix/limits/assignature/assignature.component';
import { AddBenefactorsComponent } from './master/register-of-benefactors/add-benefactors/add-benefactors.component';
import { RegisterOfBenefactorsComponent } from './master/register-of-benefactors/register-of-benefactors.component';
import { RenameYourAccountComponent } from './master/rename-your-account/rename-your-account.component';
import { UserAdminComponent } from './master/user-admin/user-admin.component';
import { LimitsComponent } from './master/limits/limits.component';
import { PaymentSecuritiesComponent } from './master/payment-securities/payment-securities.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutenticationComponent } from './autentication/autentication.component';
import { ExtractComponent } from './master/extract/extract.component';
import { TransfersOtherBanksComponent } from './master/transfers-other-banks/transfers-other-banks.component';
import { AutenticationGuard } from './autentication/autentication.guard';
import { MasterComponent } from './master/master.component';
import { MasterGuard } from './master/master.guard';
import { AppOnlyFeatureGuard } from './shared/guards/app-only-feature.guard';
import { DashboardComponent } from './master/dashboard/dashboard.component';
import { CustomerServiceComponent } from './master/customer-service/customer-service.component';
import { TransfersOmniComponent } from './master/transfers-omni/transfers-omni.component';
import { InvestmentsSimulationComponent } from './master/investments/investments-simulation/investments-simulation.component';
import { InvestmentsExtractComponent } from './master/investments/investments-extract/investments-extract.component';
import { InvestmentsPeriodComponent } from './master/investments/investments-period/investments-period.component';
import { ReceiptsComponent } from './master/receipts/receipts.component';
import { InvestmentDetailComponent } from './master/investments/investments-extract/investment-detail/investment-detail.component';
import { RescueComponent } from './master/investments/rescue/rescue.component';
import { ChangePassComponent } from './master/change-pass/change-pass.component';
import { TransactionHistoryComponent } from './master/transaction-history/transaction-history.component';
import { ChangeDigitalSignatureComponent } from './master/change-digital-signature/change-digital-signature.component';
import { DepositPerTicketComponent } from './master/deposit-per-ticket/deposit-per-ticket.component';
import { RedeemBalanceComponent } from './master/investments/redeem-balance/redeem-balance.component';
import { RatePackageComponent } from './master/rate-package/rate-package.component';
import { ReportIncomeComponent } from './master/report-income/report-income.component';
import { CardsCreditActivationStep1Component } from './master/cards-activation/credit/activation/step1/step1.component';
import { CardsCreditActivationStep2Component } from './master/cards-activation/credit/activation/step2/step2.component';
import { CardsCreditActivationStep3Component } from './master/cards-activation/credit/activation/step3/step3.component';
import { CardsCreditComponent } from './master/cards-activation/credit/credit.component';
import { CardsCreditActivationDeclinedComponent } from './master/cards-activation/credit/activation/declined/declined.component';
import { ChangeSecurityQuestionsComponent } from './master/change-security-questions/change-security-questions.component';
import { CardsComponent } from './master/cards/cards.component';
import { CollectionListComponent } from './master/collection/list/list.component';
import { CollectionCreateComponent } from './master/collection/create/create.component';
import { CollectionDetailsComponent } from './master/collection/details/details.component';
import { CollectionValueAndDateComponent } from './master/collection/value-date/value-date.component';
import { CollectionResumeFinalComponent } from './master/collection/resume-final/resume-final.component';
import { CollectionResumeBilletComponent } from './master/collection/resume-billet/resume-billet.component';
import { PixOnboardingComponent } from './master/pix/onboarding/onboarding.component';
import { PixHomeComponent } from './master/pix/home/home.component';
import { PixKeysOnboardingComponent } from './master/pix/keys/onboarding/onboarding.component';
import { PixKeysCreateComponent } from './master/pix/keys/create/create.component';
import { PixKeysComponent } from './master/pix/keys/list/list.component';
import { PixKeysCreateAssignatureComponent } from './master/pix/keys/create/assignature/assignature.component';
import { PixKeysListAssignatureComponent } from './master/pix/keys/list/assignature/assignature.component';
import { PixPaymentKeyComponent } from './master/pix/payment-key/payment-key.component';
import { PixPaymentKeyAssignatureComponent } from './master/pix/payment-key/assignature/assignature.component';
import { PixPaymentKeyFavoredCreateComponent } from './master/pix/payment-key/favored-create/favored-create.component';
import { PixPaymentKeyFavoredCreateAgencyAccountComponent } from './master/pix/payment-key/favored-create/agency-account/agency-account.component';
import { PixPaymentKeyFavoredCreateValueAndDateComponent } from './master/pix/payment-key/favored-create/value-date/value-date.component';
import { PixPaymentKeyFavoredCreateResumeComponent } from './master/pix/payment-key/favored-create/resume/resume.component';
import { PixPaymentKeyFavoredCreateResumeFinalComponent } from './master/pix/payment-key/favored-create/resume-final/resume-final.component';
import { CloseAccountInformationComponent } from './master/close-account/information/information.component';
import { CloseAccountRequestComponent } from './master/close-account/request/request.component';
import { CloseAccountStatusComponent } from './master/close-account/status/status.component';
import { CloseAccountTermsComponent } from './master/close-account/terms/terms.component';
import { PixKeysCreateValidationCodeComponent } from './master/pix/keys/create/validation-sms/validation-code.component';
import { PixReceivePaymentListComponent } from './master/pix/receive-payment/list/list.component';
import { PixReceivePaymentProfessionalComponent } from './master/pix/receive-payment/professional/professional.component';
import { PixReceivePaymentQrCodeComponent } from './master/pix/receive-payment/qr-code/qr-code-resume.component';
import { PixReceivePaymentResumeComponent } from './master/pix/receive-payment/resume/resume.component';
import { PixReceivePaymentSimpleComponent } from './master/pix/receive-payment/simple/simple.component';
import { PixRefundAssignatureComponent } from './master/pix/refund/assignature/assignature.component';
import { PixRefundResumeFinalComponent } from './master/pix/refund/resume-final/resume-final.component';
import { PixRefundValueComponent } from './master/pix/refund/value/value.component';
import { PixPaymentKeyFavoredCreateAssignatureComponent } from './master/pix/payment-key/favored-create/assignature/assignature.component';
import { PixCopyAndPasteComponent } from './master/pix/copy-and-paste/copy-and-paste.component';
import { PixKeysListAssignatureClaimComponent } from './master/pix/keys/list/assignature-claim/assignature-claim.component';
import { ReceiptsResumeFinalComponent } from './master/receipts/resume-final/resume-final.component';
import { PixReceiptComponent } from './master/pix/receipt/receipt.component';
import { PixQrCodeDynamicResumeFinalComponent } from './master/pix/copy-and-paste/qr-code-dynamic/resume-final/resume-final.component';
import { PixAdjustComponent } from './master/pix/limits/adjust/adjust.component';
import { LimiteGlobalComponent } from './master/limite-global/limite-global.component';
import { PixQrCodeDynamicAssignatureComponent } from './master/pix/copy-and-paste/qr-code-dynamic/assignature/assignature.component';
import { CollectionGuardService } from './master/collection/collection.service.guard';
import { PixWithdrawChangeComponent } from './master/pix/withdraw-change/withdraw-change.component';
import { PixWithdrawChangeResumeComponent } from './master/pix/withdraw-change/copy-and-paste/resume/resume.component';
import { PixWithdrawChangeValueDateComponent } from './master/pix/withdraw-change/copy-and-paste/value-date/value-date.component';
import { PixWithdrawChangeAssignatureComponent } from './master/pix/withdraw-change/copy-and-paste/assignature/assignature.component';
import { WithdrawChangeGuard } from './master/pix/withdraw-change/guard/withdraw-change.guard';
import { LimitsOtherLimitsComponent } from './master/limits/other-limits/other-limits.component';
import { RechargeResumeFinalComponent } from './master/receipts/recharge-resume-final/recharge-resume-final.component';
import { LimitsFaqComponent } from './master/limits/faq/faq.component';
import { TermsOfUseComponent } from './master/terms-of-use/terms-of-use.component';
import { ConcludedReceiptComponent } from './master/receipts/concluded-receipt/concluded-receipt.component';
import { BankslipReceiptComponent } from './master/receipts/bankslip-receipt/bankslip-receipt.component';
import { TransferReceiptComponent } from './master/receipts/transfer-receipt/transfer-receipt.component';
import { AntifraudWarningComponent } from './master/antifraud-warning/antifraud-warning.component';

const routes: Routes = [
	{
		path: '',
		component: MasterComponent,
		canActivate: [AutenticationGuard, MasterGuard],
		data: {
			breadcrumbs: 'Página Inicial',
			animation: { value: 'dashboard' }
		},
		children : [
			{
				path: '',
				canActivate: [MasterGuard],
				pathMatch: 'full',
				component: DashboardComponent
			},
			{

				path: 'servico-de-atendimento',
				pathMatch: 'full',
				component: CustomerServiceComponent,
				data: {
					breadcrumbs: 'Serviço de Atendimento'
				},
			},
			{
				path: 'minha-conta',
				data: {
					breadcrumbs: 'Minha Conta'
				},
				canActivate: [MasterGuard],
				children : [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'meus-limites'
					},
					{
						path: 'meus-limites',
						data : {
							breadcrumbs: 'Meus Limites'
						},
						canActivate: [MasterGuard],
						children: [
							{
								path: '',
								pathMatch: 'full',
								component: LimitsComponent,
							},
							{
								path: 'outros-limites',
								pathMatch: 'full',
								component: LimitsOtherLimitsComponent,
								data: {
									breadcrumbs: 'Outros Limites'
								}
							},
							{
								path: 'duvidas',
								pathMatch: 'full',
								component: LimitsFaqComponent,
								data: {
									breadcrumbs: 'Dúvidas'
								}
							},
						]
					},
					{
						path: 'creditback',
						component: LimiteGlobalComponent,
						data : {
							breadcrumbs: 'Creditback'
						}
					},
					{
						path: 'meu-pacote',
						component: RatePackageComponent,
						data : {
							breadcrumbs: 'Pacotes de serviços'
						}
					},
					{
						path: 'meu-pacote/:month/:year',
						component: RatePackageComponent,
						data: {
							breadcrumbs: 'Mês',
							byMonth: true
						}
					},
					{
						path: 'renomear-conta',
						component: RenameYourAccountComponent,
						data : {
							breadcrumbs: 'Renomear sua conta'
						}
					},
					{
						path: 'redefinir-senha',
						component: ChangePassComponent,
						canActivate: [AppOnlyFeatureGuard],
						data : {
							breadcrumbs: 'Redefinir senha de acesso',
							appOnlyFeatureText: 'Acesse seu app Omni Banco para alterar a senha de acesso da sua conta.'
						}
					},
					{
						path: 'redefinir-assinatura-eletronica',
						component: ChangeDigitalSignatureComponent,
						canActivate: [AppOnlyFeatureGuard],
						data : {
							breadcrumbs: 'Redefinir assinatura eletrônica',
							appOnlyFeatureText: 'Acesse seu app Omni Banco para alterar sua assinatura eletrônica.'
						}
					},
					{
						path: 'redefinir-perguntas-de-seguranca',
						component: ChangeSecurityQuestionsComponent,
						data : {
							breadcrumbs: 'Redefinir perguntas de segurança'
						}
					},
					{
						path: 'informe-de-rendimentos',
						component: ReportIncomeComponent,
						data : {
							breadcrumbs: 'Informe de rendimentos'
						}
					},
					{
						path: 'gerenciar-usuarios',
						component: UserAdminComponent,
						data : {
							breadcrumbs: 'Gerenciar usuários'
						}
					},
					{
						path: 'encerramento',
						component: CloseAccountStatusComponent,
						data : {
							breadcrumbs: 'Encerramento de conta'
						}
					},
					{
						path: 'encerramento/informacoes',
						component: CloseAccountInformationComponent,
						data : {
							breadcrumbs: 'Encerramento de conta'
						}
					},
					{
						path: 'encerramento/requisicao',
						component: CloseAccountRequestComponent,
						data : {
							breadcrumbs: 'Encerramento de conta'
						}
					},
					{
						path: 'encerramento/termos',
						component: CloseAccountTermsComponent,
						data : {
							breadcrumbs: 'Encerramento de conta'
						}
					},
					{
						path: 'encerramento/status',
						component: CloseAccountStatusComponent,
						data : {
							breadcrumbs: 'Encerramento de conta'
						}
					},
					{
						path: 'termos-de-uso',
						component: TermsOfUseComponent,
						data : {
							breadcrumbs: 'Termos e contratos'
						}
					},
				]
			},
			{
				path: 'extrato',
				data: {
					breadcrumbs: 'Extrato de Conta'
				},
				canActivate: [MasterGuard],
				children : [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'hoje'
					},
					{
						path: 'hoje',
						component: ExtractComponent,
						data: {
							breadcrumbs: 'Hoje',
							days: 0,
							byDays: true
						}
					},
					{
						path: '15-dias',
						component: ExtractComponent,
						data: {
							breadcrumbs: '15 Dias',
							days: 14,
							byDays: true
						}
					},
					{
						path: '30-dias',
						component: ExtractComponent,
						data: {
							breadcrumbs: '30 Dias',
							days: 29,
							byDays: true
						}
					},
					{
						path: 'periodo',
						component: ExtractComponent,
						data: {
							breadcrumbs: 'Período'
						}
					},
					{
						path: 'mes/:month/:year',
						component: ExtractComponent,
						data: {
							breadcrumbs: 'Mês',
							byMonth: true
						}
					}
				]
			},
			{
				path: 'transferencias',
				data: {
					breadcrumbs: 'Transferências'
				},
				canActivate: [MasterGuard],
				children : [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'transferencias-outros-bancos'
					},
					{
						path: 'transferencias-outros-bancos',
						component: TransfersOtherBanksComponent,
						data: {
							breadcrumbs: 'Outros Bancos'
						}
					},
					{
						path: 'transferencias-entre-contas',
						component: TransfersOmniComponent,
						data: {
							breadcrumbs: 'Entre contas'
						}
					},
					{
						path: 'favorecidos',
						component: RegisterOfBenefactorsComponent,
						data: {
							breadcrumbs: 'Favorecidos'
						},
						children : [
							{
								path: 'adicionar-novo-favorecido',
								component: AddBenefactorsComponent,
								data: {
									breadcrumbs: 'Adicionar novo favorecido'
								}
							}
						]
					}
				]
			},
			{
				path: 'pagamentos',
				data: {
					breadcrumbs: 'Pagamentos'
				},
				canActivate: [MasterGuard],
				children : [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'contas'
					},
					{
						path: 'contas',
						component: PaymentSecuritiesComponent,
						data: {
							breadcrumbs: 'Contas'
						}
					},
					// {
					// 	path: 'tributos-federais',
					// 	component: PaymentFederalTaxesComponent,
					// 	data: {
					// 		breadcrumbs: 'Tributos Federais'
					// 	}
					// }
				]
			},
			{
				path: 'depositos',
				data: {
					breadcrumbs: 'Depósitos'
				},
				children : [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'por-boleto'
					},
					{
						path: 'por-boleto',
						component: DepositPerTicketComponent,
						data: {
							breadcrumbs: 'Por Boleto'
						}
					}
				]
			},
			{
				path: 'cartoes',
				data: {
					breadcrumbs: 'Cartões'
				},
				children : [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'meus-cartoes'
					},
					{
						path: 'meus-cartoes',
						component: CardsComponent,
						data: {
							breadcrumbs: 'Meus Cartões'
						}
					}
				]
			},
			{
				path: 'investimentos',
				data: {
					breadcrumbs: 'Investimentos'
				},
				canActivate: [MasterGuard],
				children : [
					{
						path: '',
						pathMatch: 'full',
						redirectTo: 'simulacao'
					},
					{
						path: 'simulacao',
						component: InvestmentsSimulationComponent,
						data: {
							breadcrumbs: 'Simulação'
						}
					},
					{
						path: 'por-periodo',
						component: InvestmentsPeriodComponent,
						data: {
							breadcrumbs: 'Extrato por período'
						}
					},
					{
						path: 'extrato',
						data: {
							breadcrumbs: 'Extrato'
						},
						children : [
							{
								path: '',
								pathMatch: 'full',
								component: InvestmentsExtractComponent
							},
							{
								path: 'resgate/:id',
								component: RescueComponent,
								data: {
									breadcrumbs: 'Resgate'
								}
							}
						]
					},
					{
						path: 'extrato/:id',
						component: InvestmentDetailComponent,
						data: {
							breadcrumbs: 'Extrato'
						}
					},
					{
						path: 'resgatar-saldo',
						data: {
							breadcrumbs: 'Resgatar saldo'
						},
						children : [
							{
								path: '',
								pathMatch: 'full',
								component: RedeemBalanceComponent
							},
							{
								path: 'resgate/:id',
								component: RescueComponent,
								data: {
									breadcrumbs: 'Resgate'
								}
							}
						]
					}
				]
			},
			{
				path: 'comprovantes',
				data: {
					breadcrumbs: 'Seus Comprovantes'
				},
				canActivate: [MasterGuard],
				children : [
					{
						path: '',
						pathMatch: 'full',
						component: ReceiptsComponent
					},
					{
						path: 'transacao',
						pathMatch: 'full',
						component: ConcludedReceiptComponent
					},
					{
						path: 'visualizar',
						pathMatch: 'full',
						component: ReceiptsResumeFinalComponent
					},
					{
						path: 'recarga',
						pathMatch: 'full',
						component: RechargeResumeFinalComponent
					},
					{
						path: 'transferencia',
						pathMatch: 'full',
						component: TransferReceiptComponent
					},
					{
						path: 'boleto',
						pathMatch: 'full',
						component: BankslipReceiptComponent
					},
					{
						path: 'transacao',
						pathMatch: 'full',
						component: ConcludedReceiptComponent
					}
				]
			},
			{
				path: 'cartoes-ativacao',
				data: {
					breadcrumbs: 'Cartões'
				},
				canActivate: [MasterGuard],
				children : [
					{
						path: 'credito/reprovado',
						pathMatch: 'full',
						component: CardsCreditActivationDeclinedComponent
					},
					{
						path: 'credito/ativacao',
						pathMatch: 'full',
						component: CardsCreditComponent
					},
					{
						path: 'credito/step1',
						pathMatch: 'full',
						component: CardsCreditActivationStep1Component
					},
					{
						path: 'credito/step2',
						pathMatch: 'full',
						component: CardsCreditActivationStep2Component
					},
					{
						path: 'credito/step3',
						pathMatch: 'full',
						component: CardsCreditActivationStep3Component
					}
				]
			},
			{
				path: 'transacoes',
				data: {
					breadcrumbs: 'Transações'
				},
				canActivate: [MasterGuard],
				children : [
					{
						path: '',
						pathMatch: 'full',
						component: TransactionHistoryComponent
					}
				]
			},
			{
				path: 'cobranca',
				data: {
					breadcrumbs: 'Cobrança'
				},
				canActivate: [
					MasterGuard,
					CollectionGuardService
				],
				children : [
					{
						path: '',
						pathMatch: 'full',
						component: CollectionListComponent
					},
					{
						path: 'criar',
						pathMatch: 'full',
						component: CollectionCreateComponent
					},
					{
						path: 'editar/:id',
						pathMatch: 'full',
						component: CollectionCreateComponent
					},
					{
						path: 'detalhes/:id/:type',
						pathMatch: 'full',
						component: CollectionDetailsComponent
					},
					{
						path: 'valor-data/:type',
						pathMatch: 'full',
						component: CollectionValueAndDateComponent
					},
					{
						path: 'resumo-final',
						pathMatch: 'full',
						component: CollectionResumeFinalComponent
					},
					{
						path: 'boleto',
						pathMatch: 'full',
						component: CollectionResumeBilletComponent
					},
				]
			},
			{
				path: 'pix',
				data: {
					breadcrumbs: 'Pix'
				},
				canActivate: [MasterGuard],
				children : [
					{
						path: '',
						pathMatch: 'full',
						component: PixHomeComponent
					},
					{
						path: 'onboarding',
						pathMatch: 'full',
						component: PixOnboardingComponent
					},
					{
						path: 'home',
						pathMatch: 'full',
						component: PixHomeComponent
					},
					{
						path: 'chaves/onboarding',
						pathMatch: 'full',
						component: PixKeysOnboardingComponent
					},
					{
						path: 'chaves/criar',
						pathMatch: 'full',
						component: PixKeysCreateComponent
					},
					{
						path: 'chaves/listar',
						pathMatch: 'full',
						component: PixKeysComponent
					},
					{
						path: 'chaves/excluir',
						pathMatch: 'full',
						component: PixKeysListAssignatureComponent
					},
					{
						path: 'chaves/criar/assinatura',
						pathMatch: 'full',
						component: PixKeysCreateAssignatureComponent
					},
					{
						path: 'chaves/criar/validar-codigo',
						pathMatch: 'full',
						component: PixKeysCreateValidationCodeComponent
					},
					{
						path: 'chaves/reivindicar',
						pathMatch: 'full',
						component: PixKeysListAssignatureClaimComponent
					},
					{
						path: 'pagamento',
						pathMatch: 'full',
						component: PixPaymentKeyComponent
					},
					{
						path: 'pagamento/favorecido/excluir',
						pathMatch: 'full',
						component: PixPaymentKeyAssignatureComponent
					},
					{
						path: 'pagamento/favorecido/adicionar',
						pathMatch: 'full',
						component: PixPaymentKeyFavoredCreateComponent
					},
					{
						path: 'pagamento/favorecido/adicionar/conta',
						pathMatch: 'full',
						component: PixPaymentKeyFavoredCreateAgencyAccountComponent
					},
					{
						path: 'pagamento/favorecido/adicionar/valor-data',
						pathMatch: 'full',
						component: PixPaymentKeyFavoredCreateValueAndDateComponent
					},
					{
						path: 'pagamento/favorecido/adicionar/resumo',
						pathMatch: 'full',
						component: PixPaymentKeyFavoredCreateResumeComponent
					},
					{
						path: 'pagamento/favorecido/adicionar/comprovante',
						pathMatch: 'full',
						component: PixPaymentKeyFavoredCreateResumeFinalComponent
					},
					{
						path: 'pagamento/favorecido/adicionar/assinatura',
						pathMatch: 'full',
						component: PixPaymentKeyFavoredCreateAssignatureComponent
					},
					{
						path: 'pagamento/pix-copia-cola',
						pathMatch: 'full',
						component: PixCopyAndPasteComponent
					},
					{
						path: 'pagamento/saque-e-troco',
						pathMatch: 'full',
						component: PixWithdrawChangeComponent
					},
					{
						path: 'pagamento/saque-e-troco/pix-copia-cola',
						pathMatch: 'full',
						component: PixCopyAndPasteComponent
					},
					{
						path: 'pagamento/saque-e-troco/pix-copia-cola/valor-data',
						pathMatch: 'full',
						component: PixWithdrawChangeValueDateComponent,
						canActivate: [ WithdrawChangeGuard ]
					},
					{
						path: 'pagamento/saque-e-troco/pix-copia-cola/assinatura',
						pathMatch: 'full',
						component: PixWithdrawChangeAssignatureComponent,
						canActivate: [ WithdrawChangeGuard ]
					},
					{
						path: 'pagamento/saque-e-troco/pix-copia-cola/resumo',
						pathMatch: 'full',
						component: PixWithdrawChangeResumeComponent,
						canActivate: [ WithdrawChangeGuard ]
					},
					{
						path: 'receber',
						pathMatch: 'full',
						component: PixReceivePaymentListComponent
					},
					{
						path: 'receber/simples',
						pathMatch: 'full',
						component: PixReceivePaymentSimpleComponent
					},
					{
						path: 'receber/profissional',
						pathMatch: 'full',
						component: PixReceivePaymentProfessionalComponent
					},
					{
						path: 'receber/qr-code',
						pathMatch: 'full',
						component: PixReceivePaymentQrCodeComponent
					},
					{
						path: 'receber/resumo',
						pathMatch: 'full',
						component: PixReceivePaymentResumeComponent
					},
					{
						path: 'devolver/valor',
						pathMatch: 'full',
						component: PixRefundValueComponent
					},
					{
						path: 'devolver/assinatura',
						pathMatch: 'full',
						component: PixRefundAssignatureComponent
					},
					{
						path: 'devolver/comprovante',
						pathMatch: 'full',
						component: PixRefundResumeFinalComponent
					},
					{
						path: 'limites',
						data: {
							breadcrumbs: 'Meus Limites'
						},
						canActivate: [MasterGuard],
						children: [
							{
								path: '',
								pathMatch: 'full',
								component: LimitsComponent
							},
							{
								path: 'outros-limites',
								pathMatch: 'full',
								component: LimitsOtherLimitsComponent,
								data: {
									breadcrumbs: 'Outros Limites'
								}
							},
							{
								path: 'duvidas',
								pathMatch: 'full',
								component: LimitsFaqComponent,
								data: {
									breadcrumbs: 'Dúvidas'
								}
							},
						]
					},
					{
						path: 'comprovante/:id/:source',
						pathMatch: 'full',
						component: PixReceiptComponent
					},
					{
						path: 'pagamento/qrcode-dinamico',
						pathMatch: 'full',
						component: PixQrCodeDynamicResumeFinalComponent
					},
					{
						path: 'pagamento/qrcode-dinamico/assinatura',
						pathMatch: 'full',
						component: PixQrCodeDynamicAssignatureComponent
					},
					{
						path: 'limites/ajustar',
						pathMatch: 'full',
						component: PixAdjustComponent
					},
					{
						path: 'limites/ajustar/assinatura',
						pathMatch: 'full',
						component: PixAdjustLimitsAssignatureComponent
					},

				]
			},
			{
				path: 'aviso',
				pathMatch: 'full',
				component: AntifraudWarningComponent
			}
		]
	},
	{
		path: 'login',
		component: AutenticationComponent,
		canActivate: [AutenticationGuard],
		data: {
			animation: {
				value: 'login'
			}
		}
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
	providers: [
		// { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
	]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/app-routing.module.ts